import {createActions} from 'client/framework';

const normalActions = [
  'RESET_STORE',
  'SET_SELECTED_ITEM',
  'SET_IS_OPEN',
  'SET_OPTIONS_RECT',
  'TOGGLE_IS_OPEN'
];

export default createActions(null, normalActions);
